// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","565":"003ae7ee","769":"c2511f99"}[chunkId] + ".chunk.js";
};